import ProductManualsPage from './productManualPage';

export default ProductManualsPage;
